/**
 * Constants for WavyBackground component
 */

/**
 * Brand colors used in the wavy background animation
 * These colors represent the how.fm brand palette
 */
export const WAVY_BACKGROUND_COLORS = [
  '#8b5cf6', // Primary purple
  '#009FB4', // Logo cyan
  '#FFA620', // Logo orange
  '#5F3EA7', // Logo purple
  '#06b6d4', // Secondary cyan
] as const;

/**
 * Type for the wavy background colors array
 */
export type WavyBackgroundColors = typeof WAVY_BACKGROUND_COLORS;
